var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Achievement_center"},[_c('Arrival')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }